import "./browserify/index";
import "frontend/src/legacyStyles/fonts";
import App from "./components/App";
import * as Sentry from "@sentry/react";
import config from "./config/config";

Sentry.init({
  dsn: `https://${config.SENTRY_DSN()}`,
  tunnel: config.SENTRY_TUNNEL(),
  environment: config.SENTRY_ENVIRONMENT(),
  release: config.SENTRY_RELEASE(),
  ignoreErrors: ["ResizeObserver loop limit exceeded"],
  beforeSend(event) {
    if (
      event.environment &&
      !["dev", "staging", "production", "test"].includes(event.environment!)
    ) {
      console.log("Environment: ", event.environment);
      console.log("Stubbed Sentry Event: ", event);
      return null;
    }
    return event;
  },
});

import { createRoot } from "react-dom/client";
createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  // -- StrictMode causes double rendering issues with some libraries like antd
  // -- For debug purposes your best bet is to use StrictMode around the components of interest
  <App />
  // </React.StrictMode>
);
